import dynamic from 'next/dynamic';
import { LinkButton } from '../../../../../components/Toolkit/Button/LinkButton';
import { AdCard } from './components/AdCard/AdCard';
import { Panel } from '../shared/Panel/Panel';
import { useModal } from '../shared/FinanceModal/FinanceModal.hook';
import { type Provider } from '../../../../../components/CarFinancePage/queries/schema/carFinance.schema';
import { type LearnMoreModalProps } from './components/LearnMoreModal/LearnMoreModal';
import { Header, ProviderLogo, Heading, Copy } from './Introduction.styled';
import {
  CDN_STATIC_ASSETS,
  FEATURE_CAR_FINANCE_UPDATES,
} from '../../../../../utils';

const DynamicLearnMoreModal = dynamic<LearnMoreModalProps>(
  import('./components/LearnMoreModal/LearnMoreModal').then(
    (mod) => mod.LearnMoreModal,
  ),
  { ssr: false },
);

type IntroductionProps = {
  adId: string;
  make: string;
  model: string;
  price: number;
  provider: Provider;
};

const Introduction = (props: IntroductionProps) => {
  const { adId, make, model, price, provider } = props;

  const {
    isModalOpen: isLearnMoreModalOpen,
    openModal: openLearnMoreModal,
    closeModal: closeLearnMoreModal,
  } = useModal();

  if (FEATURE_CAR_FINANCE_UPDATES) {
    return (
      <div>
        <Header>
          <div>
            <Heading>Apply for finance</Heading>
            <LinkButton onClick={openLearnMoreModal} inline>
              Learn more about the process
            </LinkButton>
          </div>
          <ProviderLogo
            $responsive
            src={`${CDN_STATIC_ASSETS}/images/thirdparty/${provider}.svg`}
            alt={`${provider} logo`}
          />
        </Header>
        <DynamicLearnMoreModal
          isOpen={isLearnMoreModalOpen}
          onRequestClose={closeLearnMoreModal}
          provider={provider}
        />
      </div>
    );
  }

  return (
    <Panel mb={['S8', 'M16']} as="div">
      <ProviderLogo
        src={`${CDN_STATIC_ASSETS}/images/thirdparty/${provider}.svg`}
        alt={`${provider} logo`}
      />
      <Heading>Finance Application</Heading>
      <Copy>
        Apply for finance by completing the application form below.&nbsp;
        <LinkButton onClick={openLearnMoreModal} inline>
          Learn more about the process.
        </LinkButton>
      </Copy>
      <AdCard
        adId={adId}
        title={`${make} ${model}`}
        price={price}
        backgroundColor="OFFWHITE"
      />
      <DynamicLearnMoreModal
        isOpen={isLearnMoreModalOpen}
        onRequestClose={closeLearnMoreModal}
        provider={provider}
      />
    </Panel>
  );
};

export { Introduction };
